import { RostersState } from './state';

export const rostersInitialState: RostersState = {
  loaded: false,
  list: [],
  artists: {},
  operators: {},
};
